import Vue from 'vue'
import Vuex from 'vuex'
import $axios from '../router/axios'
import base64 from 'base-64'
import $cookie from 'vue-cookie'
import VNotification from 'vue-notification'

const isEmptyObject = (object) => {
  return object === null || object === undefined
    ? true
    : Object.entries(object).length === 0
    ? true
    : false
}

// Функция для получения заголовков с Authorization
const getAuthHeaders = () => {
  const token = $cookie.get('token')
  return token ? { Authorization: token } : {}
}

// === Пометки в таблице за прошлый сезон ======================================
// Пометка лежит под ключом teamId::номер::имя, а на ТМ у игрока в каждом сезоне
// свой номер. Из-за этого в таблице «за прошлый сезон» по чужому номеру всплывали
// пометки давних матчей (Lucas Silva под 73 вытаскивал чужой кружок, хотя сейчас
// он под 10). Поэтому для сезонных таблиц номер берём из ТЕКУЩЕГО матча, находя
// игрока по имени: читается и пишется ровно то, что относится к нему сегодня.
// Кого в текущем составе нет (ушёл из команды) — остаётся со своим номером.
const markNumbers = { matchKey: null, byTeam: {} };

const normMarkName = (s) => String(s || '')
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toLowerCase().replace(/[^a-z0-9]/g, '');

const matchKeyOf = (match) => String((match && (match.id || match.matchId || match.matchUrl)) || '');

// id матча за прошлый сезон — это «{id матча}-{сезон}», текущий лежит под голым id
const baseMatchId = (match) => {
  const id = String(match && match.id ? match.id : '');
  if (id) return id.split('-')[0];
  const parts = String((match && match.matchUrl) || '').split('/');
  return parts[parts.length - 1].trim();
};

const loadMarkNumbers = async (match) => {
  markNumbers.matchKey = matchKeyOf(match);
  markNumbers.byTeam = {};

  // Обычный матч за текущий сезон — номера свои, подменять нечего
  if (!match || !match.seasonLabel) return;

  const baseId = baseMatchId(match);
  if (!baseId) return;

  try {
    const { data } = await $axios.get(`/localstorage/savedMatches/${baseId}/details`, { headers: getAuthHeaders() });
    ['teamA', 'teamB'].forEach((side) => {
      const team = data && data[side];
      if (!team || !team._id) return;
      const byName = {};
      [...(team.squad || []), ...(team.addsquad || [])].forEach((player) => {
        byName[normMarkName(player.name)] = player.shirtnumber;
      });
      markNumbers.byTeam[team._id] = byName;
    });
    console.log('Пометки берём по составу текущего матча', baseId);
  } catch (error) {
    // Матч за текущий сезон удалили или его вовсе не было — работаем как раньше
    console.warn('Матч за текущий сезон не найден, пометки читаем по своим номерам:', baseId);
  }
};

const markNumber = (match, teamsId, shirtnumber, name) => {
  if (!match || markNumbers.matchKey !== matchKeyOf(match)) return shirtnumber;
  const byName = markNumbers.byTeam[teamsId];
  if (!byName) return shirtnumber;
  const mapped = byName[normMarkName(name)];
  return mapped === undefined ? shirtnumber : mapped;
};

Vue.use(Vuex)

// --- НАЧАЛО НОВОГО КОДА ---
// Функция для фоновых запросов (неубиваемая при F5 и закрытии вкладки)
// --- НАЧАЛО НОВОГО КОДА ---
const sendBackgroundRequest = (endpoint, data, method = 'POST') => {
  const token = $cookie.get('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = token;

  let baseUrl = '';
  if ($axios && $axios.defaults && $axios.defaults.baseURL) {
    baseUrl = $axios.defaults.baseURL;
  }
  const fullUrl = (baseUrl + endpoint).replace(/([^:]\/)\/+/g, "$1");

  // Превращаем данные в строку и взвешиваем
  const bodyString = JSON.stringify(data);
  const fetchOptions = {
    method: method,
    headers: headers,
    body: bodyString
  };

  // 🚀 МАГИЯ: Включаем keepalive ТОЛЬКО если вес меньше 60 КБ (лимит браузера 64 КБ)
  if (bodyString.length < 60000) {
    fetchOptions.keepalive = true;
  }

  fetch(fullUrl, fetchOptions)
  .then(res => {
    if (!res.ok) throw new Error('Ошибка сервера');
  })
  .catch(err => console.error('Ошибка фонового сохранения:', err));
};

// --- КОНЕЦ НОВОГО КОДА ---
let commentTimer = null;

/**
 * Любая ссылка ТМ на матч → «https://www.transfermarkt.com/spielbericht/index/spielbericht/{id}».
 * Домен у пользователя бывает .co.uk/.de/.world, а в пути — слаг команд.
 */
export function canonicalTmUrl(url) {
  const m = String(url || '').match(/spielbericht\/(?:index\/spielbericht\/)?(\d+)/);
  return m ? `https://www.transfermarkt.com/spielbericht/index/spielbericht/${m[1]}` : url;
}

const store = new Vuex.Store({
  state: {
    match: {
      competition: '',
      teamA: {},
      teamB: {},
    },
    hideGhostPlayers: false,
    price: [],
    preloader: false,
    // Подпись под крутилкой: у долгих загрузок меняется по ходу дела
    preloaderText: '',
    savedMatches: [],
    // Список хоть раз успешно загрузился с сервера. Пока false — синхронизацию не шлём:
    // иначе пустой список затрёт на сервере все сохранённые матчи
    savedMatchesLoaded: false,
    matchCount: '3',
    matchdayHtml: null,
    serverLogs: [], 
  },
  
  
  mutations: {
    SET_MATCHDAY_HTML(state, payload) {
      state.matchdayHtml = payload
    },
    
    SET_HIDE_GHOST_PLAYERS(state, val) {
    state.hideGhostPlayers = val;
  },
  
    SET_TEAM(state, obj) {
      state.match[obj.team] = obj.data
      // Используем нашу функцию проверки на пустоту!
      if (!isEmptyObject(obj.data)) { 
        state.match[obj.team].squad = obj.data.squad.sort(
          (a, b) => b['game-minutes'] - a['game-minutes'],
        )
      }
    },

    CLEAR_SERVER_LOGS(state) {
      state.serverLogs = [];
    },
    ADD_SERVER_LOG(state, msg) {
      // ФИЛЬТР: Пропускаем только нужные строки
      if (msg && msg.includes('Улетел запрос на TM')) {
        state.serverLogs.push(msg);
        
        // 🛡 ЗАЩИТА ПАМЯТИ: Оставляем только последние 100 записей
        if (state.serverLogs.length > 100) {
          state.serverLogs.shift(); // Удаляем самый старый лог из начала
        }
      }
    },
    
    SET_MATCH(state, obj) {
      console.log('SET_MATCH: ', state, obj)
      state.match = obj
      if (!isEmptyObject(obj.teamA) && !isEmptyObject(obj.teamB)) {
        const squadA = obj.teamA.squad.sort(
          (a, b) => b['game-minutes'] - a['game-minutes'],
        )
        const squadB = obj.teamB.squad.sort(
          (a, b) => b['game-minutes'] - a['game-minutes'],
        )
        state.match.teamA.squad = [...squadA]
        state.match.teamB.squad = [...squadB]
      }
    },
    SET_PRICE(state, obj) {
      state.price.push(obj)
    },
    SET_PRELOADER(state, val) {
      state.preloader = val
      if (!val) state.preloaderText = ''
    },
    SET_PRELOADER_TEXT(state, val) {
      state.preloaderText = val
    },
    SET_SAVED_MATCHES(state, val) {
      state.savedMatches = val
    },
    SET_SAVED_MATCHES_LOADED(state, val) {
      state.savedMatchesLoaded = val
    },
    matchCount(state, val) {
      state.matchCount = val
    },
    SET_ALL_PRICE(state, val) {
      state.price = val
    },
  },
  actions: {
    // Добавь это в секцию actions
    // 1. Точечное удаление одного матча
    async DELETE_SAVED_MATCH({ commit, getters, dispatch }, matchId) {
      const matchArray = [...getters.savedMatches];
      const filteredMatches = matchArray.filter((item) => String(item.id) !== String(matchId));
      
      // Удаляем ключи только для этого матча
      const prefix = `HIDE_PLAYER_${matchId}_`;
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith(prefix)) {
          localStorage.removeItem(key);
          i--; // Сдвигаем индекс, так как массив ключей уменьшился
        }
      }

      commit("SET_SAVED_MATCHES", filteredMatches);
      // Точечно: общий синк переписывает весь список и затирает чужие правки
      sendBackgroundRequest(`/localstorage/savedMatches/${matchId}`, {}, 'DELETE');
    },

    // 2. ПОЛНАЯ ОЧИСТКА ВСЕХ МАТЧЕЙ
    async CLEAR_ALL_SAVED_MATCHES({ commit, dispatch }) {
      // Удаляем ВООБЩЕ ВСЕ ключи, которые начинаются на HIDE_PLAYER_
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('HIDE_PLAYER_')) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(k => localStorage.removeItem(k));
      
      console.log(`🧹 Глобальная очистка: удалено меток скрытых игроков: ${keysToRemove.length}`);

      // Очищаем список и синхронизируем с сервером
      commit("SET_SAVED_MATCHES", []);
      dispatch('SYNC_SAVED_MATCHES_BACKGROUND');
    },

    SYNC_SAVED_MATCHES_BACKGROUND({ state }) {
      // Пока список не загрузился, отправлять его нельзя: на сервер уйдёт пустота
      // и затрёт все сохранённые матчи. Именно так они и пропадали.
      if (!state.savedMatchesLoaded) {
        console.warn('Список сохранённых ещё не загружен — синхронизацию пропускаем, чтобы не затереть матчи на сервере');
        return;
      }
      sendBackgroundRequest('/localstorage/savedMatches', [...state.savedMatches]);
    },

  async GET_SAVED_MATCHES_FROM_LOCAL_STORAGE({ commit }) {
      try {
        const { data } = await $axios.get('/localstorage/savedMatches', {
            headers: getAuthHeaders()
        })
        commit('SET_SAVED_MATCHES', isEmptyObject(data) ? [] : data)
        commit('SET_SAVED_MATCHES_LOADED', true)
      } catch (error) {
        // Список НЕ чистим: пустое состояние тут означает «не смогли прочитать»,
        // а не «матчей нет». Синхронизация останется выключенной до успешной загрузки
        console.error('Не удалось загрузить сохранённые матчи, синхронизация выключена:', error)
      }
    },
    async GET_MATCH_PRICES_FROM_LOCAL_STORAGE(state) {
    },
    async GET_SERVER_PRICE(state) {
    },
    async CHECK_PRICE(state, teamName) {
      const { data } = await $axios.get(`tm/checkname/${encodeURI(teamName)}`)
      return data
    },
    async ADD_TM_NAME(state, obj) {
      const { data } = await $axios.post(`tm/addtmname`, obj)
      return data
    },
    async GET_LEAGUE_LIST(state, obj) {
      const { data } = await $axios.post(`/leaguelist`, obj)
      return data
    },
    async PARSE_URL(state, obj) {
      // Ссылку из браузера пользователя (любой домен ТМ, со слагом команд) приводим
      // к каноническому виду: бэкенд режет адрес по www.transfermarkt.com, и с .co.uk
      // матч просто не создавался
      if (obj && obj.url) obj = { ...obj, url: canonicalTmUrl(obj.url) };

      // 1. Включаем крутилку и чистим старые логи терминала
      state.commit('SET_PRELOADER', true);
      state.commit('CLEAR_SERVER_LOGS'); 

      let logSource = null;

      try {
          // 2. Открываем канал связи для живых логов (SSE)
          // Пытаемся взять базовый URL из axios, если нет - используем /api
          const baseUrl = ($axios.defaults && $axios.defaults.baseURL) ? $axios.defaults.baseURL : '/api';
          const logsUrl = `${baseUrl}/parse/logs`.replace(/([^:]\/)\/+/g, "$1"); // Защита от двойных слешей
          
          logSource = new EventSource(logsUrl);
          
          logSource.onmessage = (event) => {
              state.commit('ADD_SERVER_LOG', event.data);
          };
          logSource.onerror = (err) => {
              // Ошибки тут обычно означают, что сервер просто закрыл канал, это нормально
              console.log("SSE канал логов завершил работу.");
          };

          // =========================================================
          // === ТВОЙ ОРИГИНАЛЬНЫЙ КОД ПАРСИНГА ===
          if (obj.team === 'match') {
              const { data } = await $axios.post('parse', {
                url: obj.url,
                count: obj.count,
                // Выбранный сезон применяется к обеим командам: селектор reldata у ТМ общий
                tournamentA: obj.tournament || "",
                tournamentB: obj.tournament || "",
              }).catch(error => {
                throw error;
              });

              if(data.error){
                alert(`${data.error}. Попробуй еще раз!`)
                return
              }
              data.teamA.comment = ''
              data.teamA.addsquad = []
              data.teamB.comment = ''
              data.teamB.addsquad = []
              
              data.matchUrl = obj.url; 
              
              if (data.teamA && data.teamB) {
                const secretKey = `tm_url_${data.teamA.name}_${data.teamB.name}`;
                localStorage.setItem(secretKey, obj.url);
              }

              // === УМНАЯ ПРОВЕРКА ЛИГИ (ЗАЩИТА ОТ ЧУЖИХ ССЫЛОК) ===
              const activeId = localStorage.getItem('active_league_id');
              const activeName = localStorage.getItem('active_league_name');

              if (activeName && data.competition && data.competition !== "Custom Match") {
                  const parserLeague = data.competition.toLowerCase();
                  const savedLeague = activeName.toLowerCase();
                  
                  // Получаем последнюю часть названия после тире (например, "a" из "serie c - a")
                  const lastPart = savedLeague.split('-').pop().trim();
                  
                  // 🔥 ИСПРАВЛЕНИЕ БАГА: Проверяем, что кусок длиннее 2 символов, 
                  // чтобы не искать совпадения по одной букве "a" или "b"
                  const isLastPartMatch = lastPart.length > 2 ? parserLeague.includes(lastPart) : false;
                  
                  // Проверяем: совпадает ли распарсенная лига с той, что в памяти?
                  if (savedLeague.includes(parserLeague) || parserLeague.includes(savedLeague) || isLastPartMatch) {
                      // Всё совпадает! Это матч из выбранной лиги, приклеиваем страну и ID
                      data.competition = activeName;
                      if (activeId) data.competitionId = activeId;
                  } else {
                      // Названия не совпадают! Это матч по прямой ссылке из ДРУГОЙ лиги.
                      console.log(`⚠️ Прямая ссылка: матч из [${data.competition}], игнорируем старую лигу [${activeName}]`);
                      // Оставляем оригинальное название от бэкенда и очищаем "залипшую" память
                      localStorage.removeItem('active_league_id');
                      localStorage.removeItem('active_league_name');
                  }
              }
              // ========================================================

              state.commit('SET_MATCH', data)
              return data
          } else {
            const team = obj.team
            const { data } = await $axios.post('parse', {
              url: obj.url,
              seasonValue: obj.seasonValue,
              count: obj.count, 
            }).catch(error => {
              alert(`Ошибка запроса: ${error.message}`);
              throw error;
            });
            data.comment = ''
            data.addsquad = []
            state.commit('SET_TEAM', {
              team,
              data,
            })
            return data
          }
          // === КОНЕЦ ОРИГИНАЛЬНОГО КОДА ===
          // =========================================================

      } finally {
        // 3. САМОЕ ВАЖНОЕ: Закрываем канал логов и выключаем прелоадер
        if (logSource) {
            logSource.close();
        }
        state.commit('SET_PRELOADER', false);
      }
    },
    async GET_SAVED_COLOR(state) {
      const match = state.getters.matches;
      
      let matchId = match.id || match.matchId;
      if (!matchId && match.matchUrl) {
        const parts = match.matchUrl.split('/');
        matchId = parts[parts.length - 1].trim();
      }

      const getBoolean = (stringToBoolean) => {
        return stringToBoolean === 'true' || stringToBoolean === true;
      };

      const getAllStorageData = async (teamId, squad) => {
        if (!squad || squad.length === 0) return {};
        const keys = [];

        squad.forEach(player => {
          const num = markNumber(match, teamId, player.shirtnumber, player.name);

          ['black', 'blue', 'lightblue'].forEach(color => {
            keys.push(`COLOR_${teamId}::${num}::${color}::${player.name}`);
          });

          keys.push(`LU_${teamId}::${num}::${player.name}`);
          keys.push(`YC_${teamId}::${num}::${player.name}`);
          keys.push(`NM_${teamId}::${num}::${player.name}`);
          keys.push(`gamerStatus_${teamId}::${num}::${player.name}`);
          keys.push(`playerStatus${teamId}::${num}::${player.name}`);
        });

        try {
          const { data } = await $axios.post('/localstorage/batch', { keys: keys }, { headers: getAuthHeaders() });
          return data;
        } catch (error) {
          return {};
        }
      };

      const processSquadData = async (squadArray, teamId, storageData) => {
        if (!squadArray) return [];
        const filteredSquad = [];

        for (let item of squadArray) {
          if (matchId) {
            // 🔥 Читаем удаление напрямую из памяти браузера
            const hideKey = `HIDE_PLAYER_${matchId}_${teamId}_${item.shirtnumber}_${item.name}`;
            const isHidden = localStorage.getItem(hideKey);
            if (isHidden === 'true') {
              console.log("🟢 ЗАГРУЗКА: Игрок удален (реактивность сработала) ->", hideKey);
              continue; // Игрок удален, вырезаем!
            }
          }

          const num = markNumber(match, teamId, item.shirtnumber, item.name);

          const blackValue = storageData[`COLOR_${teamId}::${num}::black::${item.name}`];
          const blueValue = storageData[`COLOR_${teamId}::${num}::blue::${item.name}`];
          const lightblueValue = storageData[`COLOR_${teamId}::${num}::lightblue::${item.name}`];
          const ycValue = storageData[`YC_${teamId}::${num}::${item.name}`];
          const nmValue = storageData[`NM_${teamId}::${num}::${item.name}`];
          const luValue = storageData[`LU_${teamId}::${num}::${item.name}`];
          const gamerStatusValue = storageData[`gamerStatus_${teamId}::${num}::${item.name}`];
          const playerStatusValue = storageData[`playerStatus${teamId}::${num}::${item.name}`];

          item.black = getBoolean(blackValue);
          item.blue = getBoolean(blueValue);
          item.lightblue = getBoolean(lightblueValue);
          item.LU = luValue;
          item.yellowCardStatus = getBoolean(ycValue);

          // Ушедших из команды помечаем автоматически: красный самолёт + зачёркнутое имя.
          // Только как значение по умолчанию — если пользователь выставил статус руками
          // (в том числе снял пометку), берём его. Поэтому проверяем наличие ключа,
          // а не «истинность»: сохранённый "0" — это осознанный выбор, а не пустота.
          const hasStored = (v) => v !== undefined && v !== null && v !== '';

          item.gamerStatus = hasStored(gamerStatusValue)
            ? (Number(gamerStatusValue) || 0)
            : (item.leftTeam ? 6 : 0);

          item.playerStatus = hasStored(playerStatusValue)
            ? playerStatusValue
            : (item.leftTeam ? ' red_text ' : playerStatusValue);

          // Vue импортирован глобально в самом верху файла
          Vue.set(item, 'NM', nmValue || ''); 
          
          filteredSquad.push(item);
        }
        
        return filteredSquad;
      };

      try {
        // Для таблицы за прошлый сезон подтянем номера игроков из текущего матча
        await loadMarkNumbers(match);

        const promises = [];

        if (match.teamA && match.teamA._id) {
          const teamAKeys = [...(match.teamA.squad || []), ...(match.teamA.addsquad || [])];
          if (teamAKeys.length > 0) promises.push(getAllStorageData(match.teamA._id, teamAKeys));
        }

        if (match.teamB && match.teamB._id) {
          const teamBKeys = [...(match.teamB.squad || []), ...(match.teamB.addsquad || [])];
          if (teamBKeys.length > 0) promises.push(getAllStorageData(match.teamB._id, teamBKeys));
        }

        const storageDataArray = await Promise.all(promises);
        const combinedStorageData = Object.assign({}, ...storageDataArray);

        // 🚀 ИСПРАВЛЕНИЕ РЕАКТИВНОСТИ VUE 🚀
        // Создаем новые объекты (копии), чтобы Vue 100% перерисовал интерфейс
        if (match.teamA && match.teamA._id) {
          const newTeamA = { ...match.teamA }; // Создаем клон
          newTeamA.squad = await processSquadData(match.teamA.squad, match.teamA._id, combinedStorageData);
          newTeamA.addsquad = await processSquadData(match.teamA.addsquad, match.teamA._id, combinedStorageData);
          state.commit('SET_TEAM', { team: 'teamA', data: newTeamA }); // Отправляем клон, экран обновляется!
        }

        if (match.teamB && match.teamB._id) {
          const newTeamB = { ...match.teamB }; // Создаем клон
          newTeamB.squad = await processSquadData(match.teamB.squad, match.teamB._id, combinedStorageData);
          newTeamB.addsquad = await processSquadData(match.teamB.addsquad, match.teamB._id, combinedStorageData);
          state.commit('SET_TEAM', { team: 'teamB', data: newTeamB }); // Отправляем клон, экран обновляется!
        }

      } catch (error) {
        console.error('Error in GET_SAVED_COLOR:', error); 
      }
    },

    async CHANGE_PRICE({ commit }, obj) {
      sendBackgroundRequest('/localstorage', {
        key: `PP_${obj.player.name.toLowerCase().replace(/\s/, '_')}::${obj.player.shirtnumber}`,
        value: obj.newPrice
      });
    },

    async CLEAR_SAVED_COLOR({ getters }, id) {
      const match = getters.matches;
      const team = match.teamA._id === id ? match.teamA.squad : match.teamB.squad;
      const keysToDelete = [];
      for (let item of team) {
        const num = markNumber(match, id, item.shirtnumber, item.name);
        ['black', 'blue', 'lightblue'].forEach(color => keysToDelete.push(`COLOR_${id}::${num}::${color}::${item.name}`));
      }
      if (keysToDelete.length > 0) sendBackgroundRequest('/localstorage/batch', { keys: keysToDelete }, 'DELETE');
    },

    async CLEAR_SAVED_LU({ getters }, id) {
      const match = getters.matches;
      const team = match.teamA._id === id ? match.teamA.squad : match.teamB.squad;
      const keysToDelete = team.map(item => `LU_${id}::${markNumber(match, id, item.shirtnumber, item.name)}::${item.name}`);
      if (keysToDelete.length > 0) sendBackgroundRequest('/localstorage/batch', { keys: keysToDelete }, 'DELETE');
    },

    async CLEAR_SAVED_STATUS({ getters }, id) {
      const match = getters.matches;
      const team = match.teamA._id === id ? match.teamA.squad : match.teamB.squad;
      const keysToDelete = [];
      for (let item of team) {
        const num = markNumber(match, id, item.shirtnumber, item.name);
        keysToDelete.push(`gamerStatus_${id}::${num}::${item.name}`);
        // Без подчёркивания: SAVE_PLAYER_STATUS и GET_SAVED_COLOR пишут и читают
        // именно такой ключ. С подчёркиванием удалялся несуществующий, и раскраска
        // имени возвращалась после перезагрузки
        keysToDelete.push(`playerStatus${id}::${num}::${item.name}`);
        item.playerStatus = '';
        item.gamerStatus = 0;
      }
      if (keysToDelete.length > 0) sendBackgroundRequest('/localstorage/batch', { keys: keysToDelete }, 'DELETE');
    },

    async SAVE_PLAYER_STATUS({ commit, getters }, { teamsId, id, name, val }) {
      const num = markNumber(getters.matches, teamsId, id, name);
      sendBackgroundRequest('/localstorage', { key: `playerStatus${teamsId}::${num}::${name}`, value: val });
    },

    async SAVE_COLOR({ commit, getters }, { teamsId, id, color, name }) {
      const match = getters.matches;
      const updateTeam = (teamObj) => {
        teamObj.squad.forEach((item) => {
          if (item.shirtnumber === id && item.name === name) item[color] = !item[color];
        });
        return teamObj;
      };
      if (teamsId === match.teamA._id) commit('SET_TEAM', { team: 'teamA', data: updateTeam({ ...match.teamA }) });
      else if (teamsId === match.teamB._id) commit('SET_TEAM', { team: 'teamB', data: updateTeam({ ...match.teamB }) });

      const num = markNumber(match, teamsId, id, name);
      sendBackgroundRequest('/localstorage', { key: `COLOR_${teamsId}::${num}::${color}::${name}`, value: true });
    },

    async SAVE_COLOR_BATCH({ commit, getters }, payload) {
      if (!payload || payload.length === 0) return;
      const teamsId = payload[0].teamsId;
      const match = getters.matches;
      const updateTeam = (teamObj) => {
        teamObj.squad.forEach((item) => {
          const playerObj = payload.find(p => p.id === item.shirtnumber && p.name === item.name);
          if (playerObj) item[playerObj.color] = true;
        });
        return teamObj;
      };
      if (teamsId === match.teamA._id) commit('SET_TEAM', { team: 'teamA', data: updateTeam({ ...match.teamA }) });
      else if (teamsId === match.teamB._id) commit('SET_TEAM', { team: 'teamB', data: updateTeam({ ...match.teamB }) });

      const batchItems = payload.map(obj => ({
        key: `COLOR_${obj.teamsId}::${markNumber(match, obj.teamsId, obj.id, obj.name)}::${obj.color}::${obj.name}`,
        value: "true"
      }));
      sendBackgroundRequest('/localstorage/batchKeyValues', { items: batchItems });
    },
    async SAVE_YELLOW_CARD({ commit, getters }, obj) {
      const player = obj.team.squad[obj.data.index];
      const num = markNumber(getters.matches, obj.team._id, player.shirtnumber, player.name);
      sendBackgroundRequest('/localstorage', {
        key: `YC_${obj.team._id}::${num}::${player.name}`,
        value: obj.data.data
      });
    },
    async SAVE_STATUS({ commit, getters }, { teamsId, id, item_id, name }) {
      const match = getters.matches;
      const updateTeam = (teamObj) => {
        teamObj.squad.forEach((item) => { if (item.shirtnumber === id && item.name === name) item.gamerStatus = item_id; });
        return teamObj;
      };
      if (teamsId === match.teamA._id) commit('SET_TEAM', { team: 'teamA', data: updateTeam({ ...match.teamA }) });
      else if (teamsId === match.teamB._id) commit('SET_TEAM', { team: 'teamB', data: updateTeam({ ...match.teamB }) });

      const num = markNumber(match, teamsId, id, name);
      sendBackgroundRequest('/localstorage', { key: `gamerStatus_${teamsId}::${num}::${name}`, value: item_id });
    },
    async SAVE_LINEUP({ commit, getters }, { shirtnumber, teamsId, lineupStatus, name }) {
      let status = lineupStatus === null || lineupStatus === 'null' || lineupStatus === '' ? 'squad' : (lineupStatus === 'squad' ? 'substitutions' : null);
      const match = getters.matches;
      const updateTeam = (teamObj) => {
        teamObj.squad.forEach((item) => { if (item.shirtnumber === shirtnumber && item.name === name) item.LU = status; });
        return teamObj;
      };
      if (teamsId === match.teamA._id) commit('SET_TEAM', { team: 'teamA', data: updateTeam({ ...match.teamA }) });
      else if (teamsId === match.teamB._id) commit('SET_TEAM', { team: 'teamB', data: updateTeam({ ...match.teamB }) });

      const num = markNumber(match, teamsId, shirtnumber, name);
      sendBackgroundRequest('/localstorage', { key: `LU_${teamsId}::${num}::${name}`, value: status });
    },
    async SAVE_NEW_MATCH({ commit, getters }, { shirtnumber, teamsId, matchStatus, name }) {
      let status = matchStatus === null || matchStatus === 'null' ? 'squad' : (matchStatus === 'squad' ? 'substitutions' : null);
      const match = getters.matches;
      const updateTeam = (teamObj) => {
        teamObj.squad.forEach((item) => { if (item.shirtnumber === shirtnumber && item.name === name) item.NM = status; });
        return teamObj;
      };
      if (teamsId === match.teamA._id) commit('SET_TEAM', { team: 'teamA', data: updateTeam({ ...match.teamA }) });
      else if (teamsId === match.teamB._id) commit('SET_TEAM', { team: 'teamB', data: updateTeam({ ...match.teamB }) });

      const num = markNumber(match, teamsId, shirtnumber, name);
      sendBackgroundRequest('/localstorage', { key: `NM_${teamsId}::${num}::${name}`, value: status });
    },

    SAVE_LINEUP_BATCH({ commit, getters }, players) {
      const match = getters.matches;
      players.forEach(obj => {
        let status = obj.lineupStatus === null || obj.lineupStatus === 'null' || obj.lineupStatus === '' ? 'squad' : (obj.lineupStatus === 'squad' ? 'substitutions' : null);
        if (obj.teamsId === match.teamA._id) {
          const teamA = { ...match.teamA };
          teamA.squad = teamA.squad.map(item => (item.shirtnumber === obj.shirtnumber && item.name === obj.name) ? { ...item, LU: status } : item);
          commit('SET_TEAM', { team: 'teamA', data: teamA });
        } else if (obj.teamsId === match.teamB._id) {
          const teamB = { ...match.teamB };
          teamB.squad = teamB.squad.map(item => (item.shirtnumber === obj.shirtnumber && item.name === obj.name) ? { ...item, LU: status } : item);
          commit('SET_TEAM', { team: 'teamB', data: teamB });
        }
      });
      const saveData = players.map(obj => {
        let status = obj.lineupStatus === null || obj.lineupStatus === 'null' || obj.lineupStatus === '' ? 'squad' : (obj.lineupStatus === 'squad' ? 'substitutions' : null);
        const num = markNumber(match, obj.teamsId, obj.shirtnumber, obj.name);
        return { key: `LU_${obj.teamsId}::${num}::${obj.name}`, value: status };
      });
      sendBackgroundRequest('/localstorage/batchKeyValues', { items: saveData });
    },

    /**
     * Импорт составов из онлайнпроги (кнопка «📋 В офлайн + составы»).
     * Приходит { A: [[имя, номер, 'start'|'sub'], ...], B: [...] } — уже готовые статусы,
     * поэтому, в отличие от SAVE_LINEUP_BATCH, ничего не переключаем по кругу, а ставим прямо:
     * start → 'squad' (красный кружок), sub → 'substitutions' (жёлтый).
     * Игрока ищем по имени (обе проги парсят один и тот же ТМ), номер — подстраховка:
     * у части игроков номера нет вовсе, там «-».
     */
    IMPORT_LINEUP({ commit, getters }, payload) {
      const match = getters.matches;
      if (!match || !match.teamA || !match.teamB) return { applied: 0, missed: [] };

      // Старые кружки LU снимаем целиком: раз состав приехал из онлайна, он и есть истина,
      // а остатки ручной разметки от прошлой версии состава только путали бы.
      const cleared = [];
      [match.teamA, match.teamB].forEach(t => {
        (t.squad || []).forEach(p => cleared.push(`LU_${t._id}::${markNumber(match, t._id, p.shirtnumber, p.name)}::${p.name}`));
      });
      if (cleared.length > 0) sendBackgroundRequest('/localstorage/batch', { keys: cleared }, 'DELETE');

      const norm = (s) => String(s || '')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')   // snimaem diakritiku: Mustafa
        .toLowerCase().replace(/[^a-z0-9]/g, '');

      const items = [];
      let applied = 0;
      const missed = [];

      const applySide = (teamObj, teamKey, rows) => {
        if (!teamObj || !Array.isArray(rows)) return teamObj;
        // Снятые выше кружки убираем и из состояния, иначе в UI останется старая разметка
        const squad = (teamObj.squad || []).map(p => ({ ...p, LU: null }));
        rows.forEach(([name, number, lu]) => {
          const status = lu === 'start' ? 'squad' : (lu === 'sub' ? 'substitutions' : null);
          if (!status) return;
          let i = squad.findIndex(p => norm(p.name) === norm(name));
          if (i < 0 && number && number !== '-') {
            i = squad.findIndex(p => String(p.shirtnumber) === String(number));
          }
          if (i < 0) { missed.push(name); return; }
          squad[i] = { ...squad[i], LU: status };
          items.push({
            key: `LU_${teamObj._id}::${markNumber(match, teamObj._id, squad[i].shirtnumber, squad[i].name)}::${squad[i].name}`,
            value: status
          });
          applied++;
        });
        const updated = { ...teamObj, squad };
        commit('SET_TEAM', { team: teamKey, data: updated });
        return updated;
      };

      applySide(match.teamA, 'teamA', payload.A);
      applySide(match.teamB, 'teamB', payload.B);

      if (items.length > 0) sendBackgroundRequest('/localstorage/batchKeyValues', { items });
      return { applied, missed };
    },

    /**
     * Проставляет LU одной команде по составу, распознанному с картинки.
     * В отличие от SAVE_LINEUP_BATCH ничего не переключает по кругу: статус уже известен.
     * Ранее действие сбрасывало LU всей команде — из-за этого вторая картинка (лавка)
     * стирала кружки, проставленные первой (старт). Теперь ничего не сбрасываем.
     */
    APPLY_LINEUP_FROM_IMAGE({ commit, getters }, { teamsId, rows }) {
      const match = getters.matches;
      if (!match || !match.teamA || !match.teamB) return { applied: 0 };

      const teamKey = match.teamA._id === teamsId ? 'teamA'
        : (match.teamB._id === teamsId ? 'teamB' : null);
      if (!teamKey) return { applied: 0 };

      // Ставим ТОЛЬКО тех, кто пришёл с картинки, остальных не трогаем: старт и лавку
      // часто вставляют двумя картинками подряд, и сброс всей команды стирал первую
      const teamObj = match[teamKey];
      const squad = (teamObj.squad || []).map(p => ({ ...p }));
      const items = [];
      let applied = 0;

      rows.forEach(({ name, shirtnumber, lu }) => {
        const status = lu === 'start' ? 'squad' : (lu === 'sub' ? 'substitutions' : null);
        if (!status) return;
        const i = squad.findIndex(p => p.name === name && String(p.shirtnumber) === String(shirtnumber));
        if (i < 0) return;
        squad[i] = { ...squad[i], LU: status };
        items.push({
          key: `LU_${teamsId}::${markNumber(match, teamsId, squad[i].shirtnumber, squad[i].name)}::${squad[i].name}`,
          value: status
        });
        applied++;
      });

      commit('SET_TEAM', { team: teamKey, data: { ...teamObj, squad } });
      if (items.length > 0) sendBackgroundRequest('/localstorage/batchKeyValues', { items });

      return { applied };
    },

    SAVE_NEW_MATCH_BATCH({ commit, getters }, players) {
      const match = getters.matches;
      players.forEach(obj => {
        let status = obj.matchStatus === null || obj.matchStatus === 'null' ? 'squad' : (obj.matchStatus === 'squad' ? 'substitutions' : null);
        if (obj.teamsId === match.teamA._id) {
          const teamA = { ...match.teamA };
          teamA.squad = teamA.squad.map(item => (item.shirtnumber === obj.shirtnumber && item.name === obj.name) ? { ...item, NM: status } : item);
          commit('SET_TEAM', { team: 'teamA', data: teamA });
        } else if (obj.teamsId === match.teamB._id) {
          const teamB = { ...match.teamB };
          teamB.squad = teamB.squad.map(item => (item.shirtnumber === obj.shirtnumber && item.name === obj.name) ? { ...item, NM: status } : item);
          commit('SET_TEAM', { team: 'teamB', data: teamB });
        }
      });
      const saveData = players.map(obj => {
        let status = obj.matchStatus === null || obj.matchStatus === 'null' ? 'squad' : (obj.matchStatus === 'squad' ? 'substitutions' : null);
        const num = markNumber(match, obj.teamsId, obj.shirtnumber, obj.name);
        return { key: `NM_${obj.teamsId}::${num}::${obj.name}`, value: status };
      });
      sendBackgroundRequest('/localstorage/batchKeyValues', { items: saveData });
    },
   async ADD_SAVED_MATCHES(state, val) {
      // Иногда название команды не доезжает: если ТМ его не отдал, поле name
      // отсутствует в JSON (jackson.default-property-inclusion: non_null), и в списке
      // сохранённых вместо матча видно « - ». При этом сам матч на экране открыт
      // и названия там есть — берём их оттуда.
      const openMatch = state.getters.matches || {};
      // Берём названия только если на экране открыт ИМЕННО этот матч,
      // иначе подставились бы команды соседнего
      const sameMatch =
        (val.matchUrl && openMatch.matchUrl && val.matchUrl === openMatch.matchUrl) ||
        (val.id && openMatch.id && String(val.id) === String(openMatch.id));

      if (sameMatch) {
        ['teamA', 'teamB'].forEach((side) => {
          if (val[side] && !val[side].name) {
            const fallback = openMatch[side] && openMatch[side].name;
            if (fallback) {
              val[side].name = fallback;
              console.warn(`Название ${side} не пришло с сервера, взяли из открытого матча: ${fallback}`);
            }
          }
        });
      }

      if (!isEmptyObject(val.teamA) && !isEmptyObject(val.teamB)) {
        let saved = await state.getters.savedMatches;

        let newMatchId = null;

        // 🌟 ОПЕРАЦИЯ МАСКИРОВКА ДЛЯ КАСТОМНЫХ МАТЧЕЙ
        if (val.competition === 'Custom Match') {
          // Берем наши 8 цифр (если они уже есть) или генерируем новые
          const safeId = val.id || Math.floor(10000000 + Math.random() * 90000000).toString();
          
          // Создаем идеальную фейковую ссылку, чтобы бэкенд не ругался при разделении по '/'
          val.matchUrl = `https://www.transfermarkt.com/custom/aufstellung/spielbericht/${safeId}`;
          newMatchId = safeId;
        } 
        // Стандартная логика для обычных матчей TM
        else if (val.matchUrl) {
          const parts = val.matchUrl.split('/');
          newMatchId = parts[parts.length - 1].trim();
        }

        // Бронебойная страховка: если ID всё еще пустой, вбиваем цифры силой
        if (!newMatchId || newMatchId === "") {
          newMatchId = Math.floor(10000000 + Math.random() * 90000000).toString();
        }

        // Один и тот же матч, распарсенный за разные сезоны, — это разные записи.
        // Без суффикса ID совпадает (он берётся из ссылки) и новый матч затирает старый.
        const seasonKey = (val.seasonLabel || '').replace(/[^A-Za-z0-9]/g, '');
        if (seasonKey) {
          newMatchId = `${newMatchId}-${seasonKey}`;
        }

        // Присваиваем финальные значения
        val.id = newMatchId;
        // savedId — то же самое, но внутри самого матча: бэкенд иначе выводит ID из ссылки
        // и для двух сезонов получает один и тот же
        val.savedId = newMatchId;
        val.teamAName = val.teamA.name;
        val.teamBName = val.teamB.name;

        if (saved.length > 0) {
          // Безопасный фильтр: ищем точный индекс дубликата
          const existingIndex = saved.findIndex((row) => {
            if (row.id && newMatchId) {
              return String(row.id) === String(newMatchId);
            }
            const rTeamA = row.teamAName || (row.teamA && row.teamA.name);
            const rTeamB = row.teamBName || (row.teamB && row.teamB.name);
            return rTeamA === val.teamAName
                && rTeamB === val.teamBName
                && (row.seasonLabel || '') === (val.seasonLabel || '');
          });

          if (existingIndex === -1) {
            // Матча нет — добавляем
            saved.push(val);
            state.commit('SET_SAVED_MATCHES', saved);
            sendBackgroundRequest('/localstorage/savedMatches/one', val);
          } else {
            // 🔥 МАГИЯ: Матч есть — ЗАМЕНЯЕМ его на обновленный
            console.log('🔄 Матч найден в базе. Обновляем данные (заменяем на перепарсенный)...');
            saved.splice(existingIndex, 1, val);
            state.commit('SET_SAVED_MATCHES', saved);
            sendBackgroundRequest('/localstorage/savedMatches/one', val);
          }
        } else {
          // База пустая — просто добавляем
          saved.push(val);
          state.commit('SET_SAVED_MATCHES', saved);
          sendBackgroundRequest('/localstorage/savedMatches/one', val);
        }
      }
    },
    async SPLICE_SAVED_MATCHES(state, val) {
      let saved = await state.getters.savedMatches
      const removed = saved[val]
      saved.splice(val, 1)
      state.commit('SET_SAVED_MATCHES', saved)
      // Точечно, чтобы не переписывать весь список целиком
      const removedId = removed && (removed.savedId || removed.id)
      if (removedId) sendBackgroundRequest(`/localstorage/savedMatches/${removedId}`, {}, 'DELETE')
      else state.dispatch('SYNC_SAVED_MATCHES_BACKGROUND')
    },
    async SET_COMMENT({ commit, getters }, obj) {
      // 1. Берем текущий матч и определяем, чья это команда
      const currentMatch = { ...getters.matches };
      let teamSide = null;
      
      if (currentMatch.teamA && currentMatch.teamA._id === obj.id) {
        currentMatch.teamA.comment = obj.val;
        teamSide = 'teamA';
      } else if (currentMatch.teamB && currentMatch.teamB._id === obj.id) {
        currentMatch.teamB.comment = obj.val;
        teamSide = 'teamB';
      }

      if (!teamSide) return;

      // 2. Мгновенно обновляем текст на экране (чтобы интерфейс не тормозил)
      commit('SET_MATCH', currentMatch);

      // 3. УМНЫЙ ТАЙМЕР (Устранение дребезга / Debounce)
      // Если таймер уже был запущен (юзер быстро печатает буквы), мы его отменяем
      if (commentTimer) {
        clearTimeout(commentTimer);
      }

      // Заводим новый таймер на 1 секунду
      commentTimer = setTimeout(() => {
        const payload = {
          matchId: currentMatch.id,
          teamSide: teamSide,
          comment: obj.val
        };

        // Отправляем PATCH-запрос на сервер только когда юзер перестал печатать на 1 секунду
        sendBackgroundRequest('/localstorage/savedMatches/comment', payload, 'POST');
        
        console.log("Комментарий отправлен на сервер:", obj.val); // Для проверки в консоли
      }, 1000); 
    },
    REMOVE_PLAYER(state, obj) {
      const { teamId, player } = obj;
      const match = { ...state.getters.matches };
      
      let matchId = match.id || match.matchId;
      if (!matchId && match.matchUrl) {
        const parts = match.matchUrl.split('/');
        matchId = parts[parts.length - 1].trim();
      }

      const hideKey = `HIDE_PLAYER_${matchId}_${teamId}_${player.shirtnumber}_${player.name}`;
      console.log("🔴 УДАЛЕНИЕ: Сохраняем в память браузера ключ ->", hideKey);

      if (matchId) {
        localStorage.setItem(hideKey, 'true');
      }

      const splicePlayer = (squad, playerToRemove) => {
        if (!squad) return [];
        return squad.filter((item) => 
          item.name !== playerToRemove.name || item.shirtnumber !== playerToRemove.shirtnumber
        );
      };

      if (match.teamA && match.teamA._id === teamId) {
        match.teamA.squad = splicePlayer(match.teamA.squad, player);
        state.commit('SET_TEAM', { team: 'teamA', data: match.teamA });
      } else if (match.teamB && match.teamB._id === teamId) {
        match.teamB.squad = splicePlayer(match.teamB.squad, player);
        state.commit('SET_TEAM', { team: 'teamB', data: match.teamB });
      }
    },

    REMOVE_ADDED_PLAYER(state, obj) {
      const { teamId, player } = obj;
      const match = { ...state.getters.matches };
      
      let matchId = match.id || match.matchId;
      if (!matchId && match.matchUrl) {
        const parts = match.matchUrl.split('/');
        matchId = parts[parts.length - 1].trim();
      }

      if (matchId) {
        // 🔥 Сохраняем в память браузера
        localStorage.setItem(`HIDE_PLAYER_${matchId}_${teamId}_${player.shirtnumber}_${player.name}`, 'true');
      }

      const splicePlayer = (squad, playerToRemove) => {
        if (!squad) return [];
        return squad.filter((item) => 
          item.name !== playerToRemove.name || item.shirtnumber !== playerToRemove.shirtnumber
        );
      };

      if (match.teamA && match.teamA._id === teamId) {
        match.teamA.addsquad = splicePlayer(match.teamA.addsquad, player);
        state.commit('SET_TEAM', { team: 'teamA', data: match.teamA });
      } else if (match.teamB && match.teamB._id === teamId) {
        match.teamB.addsquad = splicePlayer(match.teamB.addsquad, player);
        state.commit('SET_TEAM', { team: 'teamB', data: match.teamB });
      }
    },

    async GET_PLAYER_DATA(context, payload) {
      // payload содержит { url, targetTeam }
      return await $axios.post('addplayer', payload);
    },

    ADD_PLAYER(state, obj) {
      try {
        console.log("1. Начало ADD_PLAYER. Пришел игрок:", obj.player.name);
        
        // 🔥 ВОЗВРАЩАЕМ ТВОЙ РАБОЧИЙ СПОСОБ получения матча
        const match = { ...state.getters.matches };
        
        const setTeam = (team, player, matchTeam) => {
          if (!team.addsquad) {
            team.addsquad = []; 
          }
          const cleanPlayer = { ...player };
          delete cleanPlayer.country;
          delete cleanPlayer.competition;
          delete cleanPlayer.season;
          delete cleanPlayer.matchName;
          delete cleanPlayer.matchUrl;
          delete cleanPlayer.teamAName;
          delete cleanPlayer.teamBName;
          delete cleanPlayer.id;
          team.addsquad.push({
            ...player,
          });
          state.commit('SET_TEAM', {
            team: matchTeam,
            data: team,
          });
          console.log("2. Игрок успешно добавлен в состав:", matchTeam);
        };

        // Закидываем игрока в нужную команду
        if (match.teamA._id === obj.teamId) {
          setTeam(match.teamA, obj.player, 'teamA');
        } else if (match.teamB._id === obj.teamId) {
          setTeam(match.teamB, obj.player, 'teamB');
        }
        
        console.log("3. Ищем этот матч в списке сохраненных...");
        
        // ВОЗВРАЩАЕМ ТВОЙ СПОСОБ получения сохраненных матчей
        const saveMatch = state.getters.savedMatches; 
        
        // Ищем индекс текущего матча в массиве сохраненных
        const matchIndex = saveMatch.findIndex(m => m.id === match.id);
        
        if (matchIndex !== -1) {
          // 🔥 САМОЕ ВАЖНОЕ: Перезаписываем старый матч на наш обновленный (с добавленным игроком)
          saveMatch[matchIndex] = match; 
          console.log("4. Матч успешно обновлен в массиве сохраненных!");
        } else {
          console.warn("⚠️ ВНИМАНИЕ! Матч не найден в списке сохраненных!");
        }
        
        // Отправляем всё на сервер
        state.commit('SET_SAVED_MATCHES', saveMatch);
        state.dispatch('SYNC_SAVED_MATCHES_BACKGROUND'); 
        
        console.log("5. ✅ ГОТОВО! Запрос отправлен на бэкенд.");

      } catch (error) {
        console.error("🚨 КРИТИЧЕСКАЯ ОШИБКА В ADD_PLAYER:", error);
      }
    },
  },
  getters: {
    matches(state) {
      return state.match
    },
    preloader(state) {
      return state.preloader
    },
    preloaderText(state) {
      return state.preloaderText
    },
    price(state) {
      return state.price
    },
    savedMatches(state) {
      return state.savedMatches
    },
    matchCount(state) {
      return state.matchCount
    },
    premissions(state) {
      try {
        const rawToken = $cookie.get('token');
        if (!rawToken) return ''; 
        
        const decodedOnce = base64.decode(rawToken);
        const decodedTwice = base64.decode(decodedOnce);
        
        const cleanJsonString = decodedTwice.substring(0, decodedTwice.lastIndexOf('}') + 1);
        
        return JSON.parse(cleanJsonString).premission;
      } catch (error) {
        console.error("🛑 Ошибка парсинга прав (premissions) в Vuex:", error.message);
        return ''; 
      }
    },
    matchdayHtml: state => state.matchdayHtml
  },
})
store.$axios = $axios

export default store;